import React from "react";
import { useDrop } from "react-dnd";
import { ItemTypes } from "../constants/reactDnD";

function CourseCodeContainer(props) {
    const [, drop] = useDrop({
        accept: ItemTypes.COURSE_CODE,
        drop: (item) => {
            // inform the user of this component that a course is here (appear)
            if(props.onCourseAppears) {
                props.onCourseAppears(item.id);
            }
            return {isQuarter: props.isQuarter};
        }
    });

    return (
        <div ref={ drop }>
            { props.children }
        </div>
    );
}

export default CourseCodeContainer;